import React from "react";
import Expencesitem from "./expencesitem";

export default function expences(props) {
  return (
    <div>
      {props.expences.map((item) => {
        return (
          <Expencesitem
            key={item.id}
            title={item.title}
            amount={item.amount}
            date={item.date}
          />
        );
      })}
    </div>
  );
}
